import { render, staticRenderFns } from "./CoralsolManejos.vue?vue&type=template&id=54a86e1e&"
import script from "./CoralsolManejos.vue?vue&type=script&lang=js&"
export * from "./CoralsolManejos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports